<template>
    <div id="all-articles">
        <div class="page-header bg-transparent" >
            <div class="content-container row">
                <div class="page-title col-12">
                    <h2>Wellbeing</h2>
                </div>
                <div class="search-bar col-12">
                    <b-form-input
                            v-model="searchQuery"
                            type="text"
                            placeholder="Search">
                    </b-form-input>
                    <b-button-group class="filter-buttons row my-5">
                        <b-button @click="filterArticles('video')" :class="{active: filter==='video'}" class="filter-button filter-button-white px-2 px-md-5 py-3 mx-2 mx-md-3 my-2">Video</b-button>
                        <b-button @click="filterArticles('audio')" :class="{active: filter==='audio'}" class="filter-button filter-button-white px-2 px-md-5 py-3 mx-2 mx-md-3 my-2">Podcast</b-button>
                        <b-button @click="filterArticles('text')" :class="{active: filter==='text'}" class="filter-button filter-button-white px-2 px-md-5 py-3 mx-2 mx-md-3 my-2">Blog</b-button>
                        <b-button @click="allArticles" :class="{active: filter===''}" class="filter-button filter-button-white px-2 px-md-5 py-3 mx-2 mx-md-3 my-2">All</b-button>
                    </b-button-group>
                </div>
            </div>
        </div>
        <div class="articles bg-white pb-5">
            <div class="content-container row">
                <div class="section-header section-header-right">
                    <div class="section-header-divider"></div>
                    <h3 class="section-header-title">ARTICLES</h3>
                </div>
                <div class="col-12 page-filter ">
                    <b-button-group class="cta-button d-inline-flex mb-5 py-2 px-3">
                        <b-button v-if="articlePayload.page" @click="previousPage" class="cta-button"><i class="fas fa-chevron-left" ></i></b-button>
                        {{articlePayload.page + 1}} of {{pages}}
                        <b-button v-if="articlePayload.page +1 < pages" @click="nextPage" class="cta-button"><i class="fas fa-chevron-right" ></i></b-button>
                    </b-button-group>
                </div>
                <div v-for="(article, index) in articles" :key="index" class="col-12 col-sm-6 col-md-3 article-wrap">
                    <a class="card" @click="selectArticle(article.post_id)">
                        <div class="card-header bg-brand-primary">
                            <img class="card-logo" :src="'/img/' + img_type[article.post_type]" />
                        </div>
                        <div class="card-body" ref="cardBody">
                            <p class="card-title" ref="cardTitle">{{ article.post_type }}</p>
                            <div class="card-text text-eclipse">{{ article.title }}</div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import axios from "axios";
    import config from "@/constants";
    export default {
        name: "AllArticles",
        components: {
        },
        data() {
            return {
                searchQuery: '',
                filter: '',
                enrolled:0,
                reccommended: 0,
                articles:{},
                resources: {},
                img_type: {
                    video: "video-white.svg",
                    text: "blog-white.svg",
                    image: "far fa-image",
                    audio: "podcast-white.svg"
                },
                articlePayload:{
                    user_id: "LayaEAP",
                    search_key: '',
                    tag: 'mind',
                    filter: '',
                    fav_only: '',
                    page: 0,
                    page_size: 12,
                    surge_only: 1
                },
                pages: ''
            };
        },
        mounted() {
            this.getArticles()
        },
        methods: {
            async getArticles(){
                let res = await axios.post(config.api_env + "/application/api-hc/get-all-resource-list",
                    this.articlePayload, config.options)
                if(res.data.success) {
                    this.resources = res.data.resources
                }else if(res.data.err && res.data.err.includes('3994')){
                    this.$store.commit('logout')
                    this.$router.push("/login")
                }
                this.articles = this.resources.filter(article => {
                    return article.title.toLowerCase().includes(this.searchQuery.toLowerCase())
                })
                this.pages = Math.ceil(res.data.count / this.articlePayload.page_size)
            },
            selectArticle(articleId){
                this.$router.push('/wellbeing/article/'+ articleId)
            },
            filterArticles(filter){
                this.filter = filter
                this.articlePayload.tag = 'mind'
                this.articlePayload.filter = filter
                this.articlePayload.fav_only = 0
                this.articlePayload.page = 0
                this.getArticles()
            },
            allArticles(){
                this.filter = ''
                this.articlePayload.page = 0
                this.articlePayload.tag = 'mind'
                this.articlePayload.filter = 'none'
                this.articlePayload.fav_only = 0
                this.getArticles()
            },
            previousPage(){
                this.articlePayload.page = this.articlePayload.page -1
                this.getArticles()
            },
            nextPage(){
                this.articlePayload.page = this.articlePayload.page +1
                this.getArticles()
            }
        },
        watch:{
            searchQuery(newQuery){
                this.articles = this.resources.filter(article => {
                    return article.title.toLowerCase().includes(newQuery.toLowerCase())
                })
            }
        },
        computed:{
            skin(){
                return this.$store.getters.skin
            },
        }
    };
</script>
<style lang="less">
    @import "../assets/_theme-0";
    #all-articles{
        .page-header {
            padding: 60px 0 0 0 ;
        }
        .page-title {
            text-align: left;
            padding-bottom: 80px;
            h2 {
                text-align: left;
                font-size: 3.8rem;
                letter-spacing: 0.7rem;
                font-family: "FilsonProBold", sans-serif;
                color: #fff;
            }
        }
        .search-bar{
            input {
                border-radius: 25px;
                height: 50px;
                font-size: 2.4rem;
                font-family: "FilsonProBook", sans-serif;
                padding: 0 30px 5px 30px;
            }
        }
        .filter-buttons{
            width: 100%;
            margin: auto;
        }
        .page-filter{
            text-align: right;
            .btn-group{
                border-radius: 25px;
                font-size: 2rem;
                font-family: FilsonProBook
             }
        }
        .paths{
            .section-header-title{
                color: #fff;
            }
            .section-header-divider{
                opacity: 0.5;
            }
        }
        .articles();
    }
</style>
